// src/pages/orders/components/bulk/BulkShiftSelector.jsx
import React from 'react';
import { Clock, Lock } from 'lucide-react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import ShiftPickerSection from '../ShiftPickerSection';
import styles from './BulkShiftSelector.module.css';

// Card chrome mirrors ShopSelector.jsx; the actual date+shift picking logic
// (fetching, auto-select, overnight-wrap handling) lives entirely in the
// existing ShiftPickerSection — not duplicated here.
const BulkShiftSelector = ({ selectedShiftId, onShiftChange, disabled }) => {
  const { t } = useLocalization();

  return (
    <div className={styles.bulkShiftSelector}>
      <div className={styles.sectionHeader}>
        <Clock size={20} />
        <h3>{t('ecomOrders.selectShift')}</h3>
        {disabled && <Lock size={16} className={styles.lockIcon} />}
      </div>

      <ShiftPickerSection
        value={selectedShiftId}
        onChange={onShiftChange}
        disabled={disabled}
      />

      {disabled && (
        <div className={styles.disabledNote}>
          Shift cannot be changed after uploading file
        </div>
      )}
    </div>
  );
};

export default BulkShiftSelector;
